export default __webpack_public_path__ + "a276263cf88a7e4838f2fbf3c0e92028.svg";